<!-- Right Sidebar -->
<div class="right-bar">
  <div class="rightbar-title">
    <a (click)="closeMenu()" class="right-bar-toggle float-right">
      <i class="mdi mdi-close"></i>
    </a>
    <h5 class="m-0 text-white">Participant Menu</h5>
  </div>
  <div class="slimscroll-menu">
    <!-- <hr class="mt-0">
    <h5 class="pl-3">Basic Settings</h5>
    <hr class="mb-0" /> -->


    <div class="p-3">
      <div class="custom-control custom-checkbox mb-2">

        <label for="participant">Select Participant</label>
        <ng-select bindLabel="name" style="z-index: 99999;" [(ngModel)]="selectedParticipant" (change)="onChange()" [clearable]="false" [searchable]="true" >
          <ng-option [value]="participant.id" *ngFor="let participant of participants">
            {{participant.name}} ({{participant.id}})
          </ng-option>
        </ng-select>
        <!-- <select id="participant" class="custom-select" (change)="onChange()" [(ngModel)]="selectedParticipant" >
          <option *ngFor="let participant of participants" [value]="participant.id">
            {{participant.name}} ({{participant.id}})
          </option>
        </select> -->
      </div>
    </div>

  </div> <!-- end slimscroll-menu-->
</div>
<!-- /Right-bar -->

<!-- Right bar overlay-->
<div class="rightbar-overlay" (click)="closeMenu()"></div>
